// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Scanning__HelpText {\n  padding: 18px 24px;\n  border-top: 1px solid #eee;\n  font-size: 0.875rem;\n  line-height: 1.46429rem;\n  color: #777;\n}\n\n.Scanning__ListItemText {\n  max-width: 75%;\n}\n", ""]);
// Exports
module.exports = exports;
